module.exports = __webpack_public_path__ + "media/images/undraw/reserve/fill_form-b24919793772287e9d1144e53115749f.png";